import { Component } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
  standalone: false,
})
export class ContactUsComponent {
  supportEmail = 'support@hezkytech.com'
  constructor(protected location: Location) {}

}
